import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '4463708183900443'
let pixelInitialized = false
let pageViewFired = false

function initPixel() {
  if (pixelInitialized) return
  pixelInitialized = true

  // Standard Meta Pixel base code
  const f: any = window
  const n: any = (f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the fbevents.js script
  const script = document.createElement('script')
  script.async = true
  script.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(script)

  // Initialize pixel
  window.fbq('init', PIXEL_ID)
}

export function useMetaPixel() {
  useEffect(() => {
    initPixel()
    if (!pageViewFired && window.fbq) {
      window.fbq('track', 'PageView')
      pageViewFired = true
    }
  }, [])
}

export function trackAddToCart() {
  if (window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Teen Pro Blueprint',
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    })
  }
}
